import { render } from "./viewPersonCard.vue?vue&type=template&id=26ff651e&scoped=true"
import script from "./viewPersonCard.vue?vue&type=script&lang=js"
export * from "./viewPersonCard.vue?vue&type=script&lang=js"

import "./viewPersonCard.vue?vue&type=style&index=0&id=26ff651e&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ff651e"]])

export default __exports__